import React, {
  ElementType,
} from 'react';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import ForwardToInboxRoundedIcon from '@mui/icons-material/ForwardToInboxRounded';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import {
  FormCategoryDTO,
} from 'dtos';
import {
  FormCategory,
} from 'dtos/formCategory';

export type CategoryOption = {
  value: FormCategory;
  label: string;
  icon: ElementType;
};

const categoryIconMap: Record<FormCategory, ElementType> = {
  [FormCategory.PatientAgreement]: AssignmentOutlinedIcon,
  [FormCategory.PCCConsent]: ContactPageOutlinedIcon,
  [FormCategory.ProcedureForm]: DescriptionOutlinedIcon,
  [FormCategory.ReferralOutgoing]: ForwardToInboxRoundedIcon,
  [FormCategory.OrderForm]: ListAltRoundedIcon,
};

export function mapFormCategoriesToOptions(
  formCategories: FormCategoryDTO[],
): CategoryOption[] {
  return formCategories.map((category) => ({
    value: category.value as FormCategory,
    label: category.name,
    icon: categoryIconMap[category.value as FormCategory] ?? DescriptionOutlinedIcon,
  }));
}

type CategoryLabelProps = {
  option: CategoryOption;
};

export function CategoryLabel({ option }: CategoryLabelProps) {
  const Icon = option.icon;

  return (
    <div className="flex items-center gap-2">
      <Icon className="!w-4 !h-4" />
      <span>{option.label}</span>
    </div>
  );
}
